module.exports = __webpack_public_path__ + "fonts/Zen_Maru_Gothic-400-[48]169.6dab402.woff2";